<template>
  <el-dialog
    :visible="true"
    :show-close="false"
    @close="abortCreate"
  >
    <ContentHeader
      slot="title"
      :title="
        $t('analysesStatusManagement.edit.title', {
          labSampleCode: formData.labSampleCode,
        })
      "
    />
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
      <el-form
        ref="form"
        label-position="top"
      >
        <EditSampleForm
          :initialData="formData"
          @update="dataUpdated"
        />

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortCreate"
          >
            {{ $t('analysesStatusManagement.edit.abortCreate') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid || hasNoValues"
            @click.prevent="handleSubmit(updateSample)"
            :loading="loading"
          >
            {{ $t('analysesStatusManagement.edit.updateSample') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { samplesApi } from '@/api';
  import analysisStatusManagementHelper from '@/mixins/AnalysisStatusManagementHelper';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import EditSampleForm from './EditSampleForm.vue';

  const defaultData = {
    productCode: null,
    productName: null,
    customerProductName: null,
    lot: null,
    date: null,
    notes: null,
    finalCustomer: null,
    customerAddress: null,
    customerHeaderData: true,
    comments: null,
    addressId: null,
    address: null,
    analysisNotes: null,
  };

  export default {
    name: 'EditSample',
    components: {
      EditSampleForm,
      ContentHeader,
      FormButtons,
    },
    props: {
      initialData: { type: Object, default: () => defaultData },
    },
    computed: {
      hasNoValues() {
        return Object.values(this.formData).every(
          (val) => val === null || val === ''
        );
      },
    },
    data() {
      return {
        formData: { ...this.initialData },
        customerId: this.initialData.customerId,
        loading: false,
      };
    },
    methods: {
      dataUpdated(data) {
        this.formData = data;
      },
      async updateSample() {
        this.loading = true;
        try {
          // create address if needed
          this.formData = await analysisStatusManagementHelper.createAddress(
            this.formData,
            this.customerId
          );
          await analysisStatusManagementHelper.updateAddressCountryFields(
            this.formData
          );
          const dataToSend = analysisStatusManagementHelper.serializeSample(
            this.formData
          );
          if (
            !this.formData.customerHeaderData &&
            this.formData.addressId === null
          ) {
            dataToSend.addressId = null;
          }
          await samplesApi.patchSample(this.formData.id, dataToSend);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('quarantine.update.success'),
          });
          this.$emit('dialogClose', { success: true });
          this.formData = { ...defaultData };
          this.loading = false;
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message:
              error.response?.status < 500
                ? error.response.data.error.message
                : this.$t('global.serverError'),
          });
          this.loading = false;
        }
      },
      abortCreate() {
        this.formData = { ...defaultData };
        this.$emit('dialogClose', { success: false });
      },
    },
  };
</script>
